import Vue from 'vue';
import axios from 'axios';
import FormData from './libs/form-data';
import UserAPI from './user';
import ResourceAPI from './libs/resource';
import UtilsAPI from './utils';

const baseURL = process.env.VUE_APP_BASE_URL;
const getOptions = () => {
    const token = localStorage.getItem('token');
    return {
        baseURL,
        headers: {
            ...token ? { authorization: `Bearer ${token}` } : {},
            // 'Content-Language': 'zhTw',
        },
    };
};

axios.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401) {
        Vue.prototype.$bus.$emit('updateToken', '');
    }
    return Promise.reject(error);
});

const API = {
    Manager: new UserAPI('manager', getOptions),
    ManagerAccess: new ResourceAPI('manager/access', getOptions),
    ManagerAuthResource: new ResourceAPI('manager/auth/resource', getOptions),
    ManagerInfoResource: new ResourceAPI('manager/info/resource', getOptions),
    News: new ResourceAPI('news', getOptions),
    Category: new ResourceAPI('category', getOptions),
    Event: new ResourceAPI('event', getOptions),
    Announcement: new ResourceAPI('announcement', getOptions),
    Report: new ResourceAPI('report', getOptions),
    Image: new ResourceAPI('image', getOptions),
    Utils: UtilsAPI(getOptions),
    Static: (url) => (/^(blob|http)/.test(url) ? url : `${baseURL}${url}`),
    FormData,
};

export default API;
